var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpPcAgeIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39778 7.66766C7.22685 7.18923 6.85022 6.76648 6.32628 6.46496C5.80235 6.16343 5.1604 6 4.5 6C3.8396 6 3.19765 6.16343 2.67372 6.46495C2.14978 6.76648 1.77315 7.18923 1.60222 7.66766",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 3,
    r: 1.5,
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpPcAgeIconBlack);
export default __webpack_public_path__ + "static/media/cp-pc-age-icon-black.cf979afe1dfb71bb6f3fd2d7c4570dfd.svg";
export { ForwardRef as ReactComponent };